import React from "react";

function AprmTable(props) {
  let rmReport = props.rmReport;

  function editButton(data) {
    props.childUpdate(data, true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  const rmMap = (rmReport) => {
    return (
      rmReport &&
      rmReport.map((item, key) => {
        return (
          <tr key={key}>
            {/* <td>{item.id === "" || undefined || null ? "-" : item.id}</td */}
            <td>
              {item.apCode === "" || undefined || null ? "-" : item.apCode}
            </td>
            <td>
              {item.apName === "" || undefined || null ? "-" : item.apName}
            </td>
            <td>
              {item.rmCode === "" || undefined || null ? "-" : item.rmCode}
            </td>
            <td>
              {item.rmName === "" || undefined || null ? "-" : item.rmName}
            </td>
            <td>
              {item.branch === "" || undefined || null ? "-" : item.branch}
            </td>

            <td>
              {item.rmMappingDate === "" || undefined || null
                ? "-"
                : item.rmMappingDate}
            </td>
            <td className="cursor-pointer" onClick={() => editButton(item)}>
              <span className="icon-Edit edit-icon"></span>
            </td>
          </tr>
        );
      })
    );
  };

  return (
    // <div className="card-box">
    <div className="table-responsive scroll-table report-table-wrapper">
      {/* {rmReport && rmReport?.length > 0 ? ( */}
        <table className="table">
          <thead>
            <tr>
              {/* <th scope="col">ID</th> */}
              <th scope="col" className="">
                AP Code
              </th>
              <th scope="col" className="text-center">
                AP Name
              </th>
              <th scope="col" className="text-center">
                RM Code
              </th>
              <th scope="col" className="text-center">
                RM Name
              </th>
              <th scope="col" className="text-center">
                Branch
              </th>
              <th scope="col" className="text-center">
                RM Mapping Date
              </th>
              <th scope="col" className="text-center">
                Change RM
              </th>
            </tr>
          </thead>
          <tbody>
            {rmMap(props.rmReport)}
            {/* <td scope="col" className="text-centerr">
              Edit
            </td> */}
          </tbody>
        </table>
      {/* ) :
      props.serverError !== "" ? (
        <div className="report-error-message">{props.serverError}</div>
      ) : (
        <div className="report-error-message">
          AP Mapping details does not exist
        </div>
      )} */}
    </div>
    // </div>
  );
}

export default AprmTable;
